import state from './moduleDiscountState'
import mutations from './moduleDiscountMutations'
import actions from './moduleDiscountActions'
import getters from './moduleDiscountGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
